import React from 'react';
import { Card } from 'semantic-ui-react';
import ApiProductsTable from '../../components/ApiProductsTable';

const ApiProduct = () => {
  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header className='header'>API 价格</Card.Header>
          <ApiProductsTable />
        </Card.Content>
      </Card>
    </div>
  );
};

export default ApiProduct;
